import Decimal from "decimal.js";
import { BundleResponse } from "../model/productsResponse";
Decimal.set({precision:2});

export const mock2: BundleResponse = [
  /*{
  "name": "LMS Only",
  "features" : [],
  "products": [
      {
          "id": "01t79000002b4b2AAA",
          "name": "Litmos LMS, Premier",
          "shortDescription": "Litmos LMS, Premier designed for mid-market and high-growth companies who need a scalable solution for a global learner base.",
          "priceTiers": [
              {
                  "minUserCount": 1,
                  "maxUserCount": 100,
                  "pricePerUser": new Decimal(6.15),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 101,
                  "maxUserCount": 250,
                  "pricePerUser": new Decimal(4.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 251,
                  "maxUserCount": 500,
                  "pricePerUser": new Decimal(3.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 501,
                  "maxUserCount": 750,
                  "pricePerUser": new Decimal(3.0),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 751,
                  "maxUserCount": 1250,
                  "pricePerUser": new Decimal(2.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 1251,
                  "maxUserCount": 2000,
                  "pricePerUser": new Decimal(2.0),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 2001,
                  "maxUserCount": 5000,
                  "pricePerUser": new Decimal(1.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 5001,
                  "maxUserCount": 10000,
                  "pricePerUser": new Decimal(1.25),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 10001,
                  "maxUserCount": 25000,
                  "pricePerUser": new Decimal(0.75),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 25001,
                  "maxUserCount": 50000,
                  "pricePerUser": new Decimal(0.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              }
          ],
          "fixedPrices": null,
          "isRecurring": true,
          "purchaseEnabled": true,
          "sku": "SUB-AU-LITLMSPRMR"
      },
      {
          "id": "01t79000002b4bmAAA",
          "name": "Litmos Training Content, Foundation",
          "shortDescription": "A suite of 140 courses, and growing, covering a range of skills, designed to kick start the learning journey.",
          "priceTiers": [
              {
                  "minUserCount": 1,
                  "maxUserCount": 100,
                  "pricePerUser": new Decimal(3.0),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 101,
                  "maxUserCount": 250,
                  "pricePerUser": new Decimal(2.0),
                  "locale": "",
                  "currencyIsoCode": "USD"
              }
          ],
          "fixedPrices": null,
          "isRecurring": true,
          "purchaseEnabled": true,
          "sku": "CON-NU-LITCONFND"
      },
      {
          "id": "01t79000002c3KcAAI",
          "name": "Litmos Service, Digital QuickStart",
          "shortDescription": "E-learning course and handbook to guide you through implementing the Litmos LMS and quickening your time to value.",
          "priceTiers": null,
          "fixedPrices": [
              {
                  "pricePerUser": new Decimal(500.0),
                  "locale": "",
                  "currencyIsoCode": "USD"
              }
          ],
          "isRecurring": false,
          "purchaseEnabled": true,
          "sku": "SRV-FX-LITDIGIQQS"
      }
  ],
  "maxUserCount": 100,
  "minUserCount": 10,
  "defaultUserCount": 20

},*/
{
  "name": "What You Tried",
  "features" : ["AI Search", "Anti-bribery and Corruption", "Antitrust, Competition, and Consumer Protection", "Diversity, Equity, and Inclusion", "Code of Conduct and Ethics", "Health and Safety (including wellbeing)", "Harassment and Discrimination", "Global Compliance (including translations)", "Information Security", "Data Protection and Privacy", "Governance and Risk", "Healthcare Compliance", "Healthcare Revenue Cycle", "Soft Skills and Workplace Communication", "Global compliance (including translations)", "Recommended courses", "Gamification & Incentives", "Self sign-up", "Dashboards", "Assessments", "Course Equivalencies", "Translation and Localization", "Learning Paths", "Video Assessments", "Learner Uploads for Compilance", "Native Mobile App", "Learning Reinforcement via Skill Boosts", "Course Ratings", "Discussion Forums", "Scheduled Course Releases in Learning Paths", "Dashboards", "Reporting with Custom Reports Engine", "SSO", "Branding & Customization", "Native Course Authoring Tool", "Custom User Attributes", "Email Template Customization", "Course Surveys", "Bulk Import Results From External Training", "Rules Engine", "E-Commerce", "Organization, Teams, and Hierarchies", "Enrollment Approvals", "Instructor Led Training & vILT", "Assign Content - Automate Assign", "Custom Tagging with Topics & Sup-topics", "1-Click Navigation for Common Features", "Webhooks", "Translation & Localization", "Integrations", "Learner Record Store", "Dashboards", "Skills & Competencies", "Assignment Reminders and KPIs", "Reporting with Custom Reports Engine", "Native Course Authoring Tool", "Assign Content - Automate Assign", "Recommendations", "AI Learning Assistant (coming soon)", "AI Course Builder (coming soon)", "E-Commerce", "Customers, Partners, and Suppliers", "Branding & Customization", "Revenue Management", "Reporting", "Embedded Experience", "SalesForce", "HRIS, ERP", "ADP", "APIs", "Bamboo HR", "Box", "Docusign", "Litmos Native Electronic Signatures", "Namely", "Shopify"],
  "products": [
      {
          "id": "01t79000002b4b2AAA",
          "name": "Litmos LMS, Premier",
          "shortDescription": "Litmos LMS, Premier designed for mid-market and high-growth companies who need a scalable solution for a global learner base.",
          "priceTiers": [
              {
                  "minUserCount": 1,
                  "maxUserCount": 100,
                  "pricePerUser": new Decimal(6.15),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 101,
                  "maxUserCount": 250,
                  "pricePerUser": new Decimal(4.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 251,
                  "maxUserCount": 500,
                  "pricePerUser": new Decimal(3.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 501,
                  "maxUserCount": 750,
                  "pricePerUser": new Decimal(3.0),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 751,
                  "maxUserCount": 1250,
                  "pricePerUser": new Decimal(2.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 1251,
                  "maxUserCount": 2000,
                  "pricePerUser": new Decimal(2.0),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 2001,
                  "maxUserCount": 5000,
                  "pricePerUser": new Decimal(1.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 5001,
                  "maxUserCount": 10000,
                  "pricePerUser": new Decimal(1.25),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 10001,
                  "maxUserCount": 25000,
                  "pricePerUser": new Decimal(0.75),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 25001,
                  "maxUserCount": 50000,
                  "pricePerUser": new Decimal(0.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              }
          ],
          "fixedPrices": null,
          "isRecurring": true,
          "purchaseEnabled": true,
          "sku": "SUB-AU-LITLMSPRMR"
      },
      {
          "id": "01t79000002b4biAAA",
          "name": "Litmos Training Content, Platinum",
          "shortDescription": "A comprehensive library of over 2000 skills-based and compliance courses designed to meet the needs of the modern organization.",
          "priceTiers": [
              {
                  "minUserCount": 1,
                  "maxUserCount": 100,
                  "pricePerUser": new Decimal(4.0),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 101,
                  "maxUserCount": 250,
                  "pricePerUser": new Decimal(2.75),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 251,
                  "maxUserCount": 500,
                  "pricePerUser": new Decimal(1.75),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 501,
                  "maxUserCount": 750,
                  "pricePerUser": new Decimal(1.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 751,
                  "maxUserCount": 1250,
                  "pricePerUser": new Decimal(1.25),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 1251,
                  "maxUserCount": 2000,
                  "pricePerUser": new Decimal(1.0),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 2001,
                  "maxUserCount": 5000,
                  "pricePerUser": new Decimal(0.75),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 5001,
                  "maxUserCount": 10000,
                  "pricePerUser": new Decimal(0.5),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 10001,
                  "maxUserCount": 25000,
                  "pricePerUser": new Decimal(0.35),
                  "locale": "",
                  "currencyIsoCode": "USD"
              },
              {
                  "minUserCount": 25001,
                  "maxUserCount": 50000,
                  "pricePerUser": new Decimal(0.25),
                  "locale": "",
                  "currencyIsoCode": "USD"
              }
          ],
          "fixedPrices": null,
          "isRecurring": true,
          "purchaseEnabled": true,
          "sku": "CON-NU-LITCONPLAT"
      },
      {
          "id": "01t79000002c3KcAAI",
          "name": "Litmos Service, Digital QuickStart",
          "shortDescription": "E-learning course and handbook to guide you through implementing the Litmos LMS and quickening your time to value.",
          "priceTiers": null,
          "fixedPrices": [
              {
                  "pricePerUser": new Decimal(500.0),
                  "locale": "",
                  "currencyIsoCode": "USD"
              }
          ],
          "isRecurring": false,
          "purchaseEnabled": true,
          "sku": "SRV-FX-LITDIGIQQS"
      }
  ],
  "maxUserCount": 100,
  "minUserCount": 10,
  "defaultUserCount": 20
}
/*,
{
  "name": "Platinum Suite",
  "features" : ["AI Search", "Anti-bribery and Corruption"],
  "products": [
      {
          "id": "01t79000002b4b1AAA",
          "name": "Litmos LMS, Platinum",
          "shortDescription": "Litmos LMS, Platinum designed for enterprise companies who need a scalable, global LMS, with deep learner engagement tools and analytics.",
          "priceTiers": null,
          "fixedPrices": null,
          "isRecurring": true,
          "purchaseEnabled": false,
          "sku": "SUB-AU-LITLMSPLAT"
      },
      {
          "id": "01t79000002b4biAAA",
          "name": "Litmos Training Content, Platinum",
          "shortDescription": "A comprehensive library of over 2000 skills-based and compliance courses designed to meet the needs of the modern organization.",
          "priceTiers": null,
          "fixedPrices": null,
          "isRecurring": true,
          "purchaseEnabled": false,
          "sku": "CON-NU-LITCONPLAT"
      },
      {
          "id": "01t79000002b4bOAAQ",
          "name": "Litmos Service, Platinum implementation",
          "shortDescription": "With Platinum customers will receive all items included in Premier plus include a custom scope. Discovery, Requirements Gathering, Project Scope, Best-practice project plan (Full customization done by LitmosStaff with program manager on customer side).\n- The project is scoped out on first call. Customer and Litmos agree on Go Live date along with follwing items to be completed and project managed by Litmos:\n- Guided onboarding with a Customer Enablement Manager for 30 days\n- Integrations: Any API consulting or integrations that are required for use case\n- All content-related work: migrating existing content (over 350 courses or modules must be agreed upon), configuring course settings, creating Learning Paths & Collections, and assignment\n- Custom branding work requested and agreed in scope\n- Complete set up of the Limos LMS including Users and Teams",
          "priceTiers": null,
          "fixedPrices": null,
          "isRecurring": false,
          "purchaseEnabled": false,
          "sku": "SRV-FX-LITPLATIMPL"
      }
  ],
  "maxUserCount": 100,
  "minUserCount": 10,
  "defaultUserCount": 20
}*/
]
